/// <amd-module name="Search/Code/Flux/Sources/CountSpy" />
import { ActionsHub } from "Search/Code/Flux/ActionsHub";
import { EntityTypeUrlParam } from "Search/Code/Constants";
import { IResultsLoadedPayload, IPageInitializedWithSeedDataPayload } from "Search/Shared/Base/ActionsHub";
import { CodeQueryResponse, CodeResult } from "Search/LegacyWebApi/Contracts/Code";
import { PivotResults } from "Search/Shared/Base/Types";
import { RelationFromExactCount } from "Search/LegacyWebApi/Contracts/Search.SharedLegacy";

export class CountSpy {
    constructor(
        private readonly resultsCount: PivotResults,
        private readonly actionsHub: ActionsHub) {
        this.registerActionsHubHandlers();
    }

    public dispose = (): void => {
        this.disposeActionsHubHandlers();
    }

    private registerActionsHubHandlers = (): void => {
        this.actionsHub.resultsLoaded.addListener(this.resultsLoadedHandler);
        this.actionsHub.pageInitializedWithSeedData.addListener(this.pageInitializedHandler);
    }

    private disposeActionsHubHandlers = (): void => {
        this.actionsHub.resultsLoaded.removeListener(this.resultsLoadedHandler);
        this.actionsHub.pageInitializedWithSeedData.removeListener(this.pageInitializedHandler);
    }

    private resultsLoadedHandler = ({ response }: IResultsLoadedPayload<CodeQueryResponse, CodeResult>): void => {
        this.onResultsLoaded(response);
    }

    private pageInitializedHandler = ({ response }: IPageInitializedWithSeedDataPayload<CodeQueryResponse>): void => {
        this.onResultsLoaded(response);
    }

    private onResultsLoaded = (response?: CodeQueryResponse): void => {
        setTimeout(() => {
            if (response) {
                this.resultsCount[EntityTypeUrlParam].value = { count: response.results.count, relationFromExactCount: RelationFromExactCount.Equals };
            }
        }, 0);
    }
}
